import { render, staticRenderFns } from "./DCIRegistrationDelo.vue?vue&type=template&id=044f2ca8&scoped=true"
import script from "./DCIRegistrationDelo.vue?vue&type=script&lang=js"
export * from "./DCIRegistrationDelo.vue?vue&type=script&lang=js"
import style0 from "./DCIRegistrationDelo.vue?vue&type=style&index=0&id=044f2ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f2ca8",
  null
  
)

export default component.exports